'use client'

/* eslint-disable arrow-body-style */
import React from 'react'

import AckodriveBreadCrumb from '@components/Ackodrive/breadCrumb'
import { TopicsContainer, TopicsWrapper, Title, TopicsList } from './styles'
import TopicItems from './TopicItems'

const TopicsListing = ({ ackodriveTopicsResponse, breadCrumb }) => {
  return (
    <TopicsContainer>
      <AckodriveBreadCrumb breadCrumbObj={breadCrumb} />
      <TopicsWrapper>
        <Title>
          <span style={{ color: '#7C47E1' }}>All </span>
          <span>Topics</span>
        </Title>
        <TopicsList>
          {ackodriveTopicsResponse?.map((topic, _index) => {
            return <TopicItems topic={topic} />
          })}
        </TopicsList>
      </TopicsWrapper>
      <AckodriveBreadCrumb breadCrumbObj={breadCrumb} />
    </TopicsContainer>
  )
}

export default TopicsListing
